import { render, staticRenderFns } from "./CriteriaPanelistsPage.vue?vue&type=template&id=2c3b3d66"
import script from "./CriteriaPanelistsPage.vue?vue&type=script&lang=ts"
export * from "./CriteriaPanelistsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports